import type { ReactNode } from "react";
import {
  useTableColumnPreferences,
  type UseTableColumnPreferencesResult,
} from "./useTableColumnPreferences";
import type { TableColumnDef } from "./types";
import { DataTablePreferencesContext } from "./dataTablePreferencesContext";

interface DataTableProviderProps<T> {
  tableId: string;
  columns: TableColumnDef<T>[];
  children: ReactNode;
}

export function DataTableProvider<T>({
  tableId,
  columns,
  children,
}: DataTableProviderProps<T>) {
  const preferences = useTableColumnPreferences(tableId, columns);
  return (
    <DataTablePreferencesContext.Provider
      value={preferences as UseTableColumnPreferencesResult<unknown>}
    >
      {children}
    </DataTablePreferencesContext.Provider>
  );
}
